import DestinationAPI from 'api/destination';
import EventsAPI from 'api/events';
import APIUtils, {APIRegistry} from '@spothero/utils/api';

export const DESTINATION_LOAD_DATA = 'DESTINATION_LOAD_DATA';
export const DESTINATION_LOAD_EVENTS = 'DESTINATION_LOAD_EVENTS';
export const DESTINATION_UPDATE = 'DESTINATION_UPDATE';
export const DESTINATION_RESET = 'DESTINATION_RESET';
export const DESTINATION_GET_AIRPORT_STRUCTURED_DATA =
    'DESTINATION_GET_AIRPORT_STRUCTURED_DATA';

export const destinationLoadData = id => {
    return {
        type: DESTINATION_LOAD_DATA,
        payload: DestinationAPI.get(id),
    };
};

export const destinationLoadEvents = ({destinationId, eventTypes, starts}) => {
    return {
        type: DESTINATION_LOAD_EVENTS,
        payload: EventsAPI.get({
            destinationId,
            eventTypes,
            starts,
        }),
    };
};

export const destinationUpdate = data => {
    return {
        type: DESTINATION_UPDATE,
        payload: data,
    };
};

export const destinationReset = () => {
    return {
        type: DESTINATION_RESET,
    };
};

export const getSpotsAirportStructuredData = iataCode => {
    return (dispatch, getState) => {
        const searchAPIUtils = APIRegistry.get('ratesSearch');
        const cancelSource = APIUtils.getCancelToken().source();
        const config = {
            cancelToken: cancelSource.token,
        };

        const params = {
            iata: iataCode,
        };

        return dispatch({
            type: DESTINATION_GET_AIRPORT_STRUCTURED_DATA,
            payload: searchAPIUtils.get('facilities/airport/', params, config),
        });
    };
};
